<template>
    <Card class="layout-card" style="height: 100%;">
        <div style="display:flex;justify-content: space-between;margin-bottom: 10px;flex-shrink: 0;">
            <div class="search-form">
                <!-- <Input :maxlength="100" v-model="searchForm.playId" placeholder="请输入短剧id" /> -->
                <Input :maxlength="100" v-model="searchForm.playName" placeholder="请输入短剧名称" />
                <div style="width: 140px;">
                  <Select v-model="searchForm.langId" placeholder="请选择语言">
                    <Option v-for="(item,index) in langList" :key="index" :value="item.id">{{ item.chineseLangName }}</Option>
                </Select>
                </div>
                <Button type="primary" v-if="buttonMenu['/track/view']" @click="getData()">查询</Button>
                <Button @click="handleReset()">重置</Button>
            </div>
            <div><Button type="primary" v-if="buttonMenu['/track/add']" @click="handleOpenEditModal()">添加</Button></div>
        </div>
        <div style="height: 100%;overflow:auto">
        <Table :data="tableData" :columns="columns" :loading="loading">
            <template #imgs="{row}">
                <div style="width: 100%;">
                    <img v-if="row.fileUrl" :src="row.fileUrl" style="width:100%;cursor:pointer" @click="$viewerApi({images:[row.fileUrl]})" />
                </div>
            </template>
            <template #isHot="{row}">
            <div>
              <i-switch v-if="buttonMenu['/track/hot']" :value="row.trackHot" :before-change="()=>handleChangeStatus(row)" @on-change="row.trackHot=$event"></i-switch>
              <span v-else> {{ row.trackHot?'是':'否' }}</span>
            </div>
            </template>
            <template #trackSort="{row,index}">
                <div style="display:flex;align-items: center;">
                  <InputNumber ref="tracksort" number :min="0" :precision="0" :max="9999" v-if="tableData[index].isEdit" v-model="row.trackSort" @on-blur="handleChangeSort(row,index)" />
                  <span v-else v-text="row.trackSort" /> 
                  <Icon type="ios-create-outline" v-if="buttonMenu['/track/sort/edit']" @click="$set(tableData, index, { ...tableData[index], isEdit:true });$nextTick(()=>{
                    $refs.tracksort.$el.querySelector('input').focus()
                  })" style="font-size:15px;margin-left: 10px;cursor:pointer;color: #2d8cf0" />
                </div>
            </template>
            <template #action="{row}">
                <div>
                    <!-- <a style="margin-left: 10px;" @click="handleOpenEditModal(row)">编辑</a> -->
                    <Poptip confirm title="确定要删除吗？" v-if="buttonMenu['/track/delete']" transfer @on-ok="handleDel(row)"><a style="margin-left: 10px;color: red">删除</a></Poptip>

                </div>
            </template>
            <Pages slot="footer" :page="page" :func="getData"></Pages>
        </Table>
        </div>

        <Modal v-model="editVisible" :title="(form.id?'编辑':'新增')+'短剧'" :width="1000">
            <movieAdd v-if="editVisible" ref="addRef" :query="{}" :func="getTrackPlayList" :showLang="true"></movieAdd>
            <template #footer>
                <Button @click="editVisible=false">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="handleSubmit()">提交</Button>
            </template>
        </Modal>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import { getTrackList, addTrack, delTrack, editTrack, getTrackPlayList, changeStatus } from '@/api/track'
import movieAdd from '../theater/components/movie-add.vue'
import { getLangList } from '../../api/lang'
export default {
  components: {
    Pages,
    movieAdd
  },
  data() {
    return {
      editVisible:false,
      form:{},
      getTrackPlayList,
      langList: [],
      searchForm:{},
      loading: false,
      submitLoading:false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      columns: [
        // {
        //   title: 'id',
        //   key: 'id'
        // },
        {
          title: '短剧名称',
          key: 'playName'
        },
        {
          title: '所属语言',
          key: 'langName'
        },
        {
          title: '封面图',
          width: 150,
          slot: 'imgs'
        },
        {
          title: '是否热播',
          slot: 'isHot'
        },
        {
          title: '排序值',
          slot: 'trackSort'
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action'
        }
      ]
    }
  },
  computed:{
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('server/track')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods:{
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      this.loading = true
      getTrackList({
        ...this.page,
        ...this.searchForm
      }).then(({ data }) => {
        this.tableData = data.records
        this.page.current = data.current
        this.page.total = data.total
        this.loading = false
    })
    },
    handleGetLang() {
      getLangList({ current: -1, size: -1, langStatus: true }).then(r => {
        this.langList = r.data.records
      })
    },
    async handleOpenEditModal(row) {
      this.form = {}
      this.editVisible = true
    },
    handleChangeSort(row, index) {
      editTrack({ ...row }).then(r => {
        this.$Message.success('操作成功')
        this.getData(this.page.current)
      }).catch(e => {
        this.$Message.success('操作失败')
      })
      this.$set(this.tableData, index, { ...row, isEdit:false })
    },
    handleSubmit() {
      const func = this.form.id ? editTrack : addTrack
      this.submitLoading = true
      func({
        playId:this.$refs.addRef.selection.map(i => i.playId)
      }).then(r => {
        this.$Message.success('操作成功')
        this.getData()
        this.submitLoading = false
        this.editVisible = false
      }).catch(() => {
        this.submitLoading = false
      })
    },
    handleDel(row) {
      delTrack(row.id).then(r => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleReset() {
      this.searchForm = {}
    },
    handleChangeStatus(row) {
      changeStatus(row.id).then(r => {
        this.$Message.success('操作成功')
        this.getData(this.page.current)
      }).catch(e => {
        this.$Message.error('操作失败')
      })
      return new Promise(() => {})
    }
  },
  mounted() {
    this.getData()
    this.handleGetLang()
  }
}
</script>

<style scoped lang="less">
.search-form{
    display:flex;
    &>*{
        margin: 0 5px;
    }
}

.layout-card{
  /deep/ .ivu-card-body{
    height: 100%;display:flex;flex-direction: column;
  }
}
/deep/.ivu-input-number-handler-wrap{
    display: none;
  }
</style>
